import { render, staticRenderFns } from "./Send-document-dialog.vue?vue&type=template&id=1f2f42b6&"
import script from "./Send-document-dialog.vue?vue&type=script&lang=js&"
export * from "./Send-document-dialog.vue?vue&type=script&lang=js&"
import style0 from "./Send-document-dialog.vue?vue&type=style&index=0&id=1f2f42b6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports